export default "__VITE_ASSET__igE0Ih2M__$_?nuxt_component=async&nuxt_component_name=IconFunctionIcons100prozentMerino&nuxt_component_export=default__"